import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MasterService } from 'src/app/services/master.service';

@Component({
  selector: 'app-reclaim-detail',
  templateUrl: './reclaim-detail.component.html',
  styleUrls: ['./reclaim-detail.component.scss']
})
export class ReclaimDetailComponent implements OnInit {
  @Input() formGroupName: string;
  @Input() contact: [];
  reclaimForm: FormGroup;
  invalidForm = true;
  themes: [];
  insurances: [];
  submitted: boolean = false;
  historySOAT: boolean = false;
  min: Date;

  constructor(
    private rootFormGroup: FormGroupDirective,
    private masterService: MasterService,
  ) { }

  ngOnInit(): void {
    this.min = new Date();
    this.reclaimForm = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    // this.getListTheme();
    this.getListInsurance();
  }

  //#region [For reclaim]
  getListTheme() {
    this.masterService.getList(13, this.reclaimForm.get('sureId').value).subscribe(
      (response: any) => {
        this.themes = response;
      }
    );
  }
  getListInsurance() {
    this.masterService.getList(12, 0).subscribe(
      (response: any) => {
        this.insurances = response;
      }
    );
  }

  changeInsurance() {
    let index = this.reclaimForm.get('sureId').value;
    let urlControlRec = this.reclaimForm.get('time');
    index !== 3 ? urlControlRec.setValidators([Validators.required]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();

    urlControlRec = this.reclaimForm.get('licensePlate');
    index === 3 ? urlControlRec.setValidators([Validators.required, Validators.minLength(6)]) : urlControlRec.clearValidators(); urlControlRec.updateValueAndValidity();

    this.historySOAT = (index === 3);


    this.getListTheme();
    
  }
  //#endregion
}
